import Navbar from "./Navbar";
import Footer from "./Footer";
import { ToDashboard } from "../auth";
import Chatbot from "../chatBot";

const RootLayout = ({ children }) => {
  return (
    <>
      <Navbar />
      <ToDashboard>{children}</ToDashboard>
      <Chatbot />
      <Footer />
    </>
  );
};

export default RootLayout;
